/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_TaglineInputs */

const en_wc_footer_tagline = /** @type {(inputs: Wc_Footer_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download. Try. Learn WordCraft.`)
};

/**
* | output |
* | --- |
* | "Download. Try. Learn WordCraft." |
*
* @param {Wc_Footer_TaglineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_tagline = /** @type {((inputs?: Wc_Footer_TaglineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_TaglineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_tagline(inputs)
});
export { wc_footer_tagline as "wc.footer.tagline" }